import axiosInstance from './util/auth_util'

const AddressServer = {
    // 获取地址
    async getAddress(){
        try{
            const response = await axiosInstance.get(`/address`)
            return response.data;
        }catch(error){
            throw error.response?.data || error.message;
        }
    },

    async getDefaultsAddress(){
        try{
            const response = await axiosInstance.get(`/address/default`)
            return response.data; 
        }catch(error){
            throw error.response?.data || error.message;
        }
    },

    // 新增地址
    async createAddress(formData){
        try{
            const response = await axiosInstance.post(`/address/add`, formData,{
                headers: {
                    'Content-Type':'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            throw error.response?.data || error.message;
        }
    },

    // 更新地址
    async updateAddress(formData){
        try{
            const response = await axiosInstance.put(`/address/update`, formData,{
                headers: {
                    'Content-Type':'multipart/form-data'
                }
            }) 
            return response.data;
        }catch(error){
            throw error.response?.data || error.message; 
        }
    },

    // 更新状态
    async updateStatus(id){
        try{
            const response = await axiosInstance.put(`/address/set_default/${id}`)
            return response.data; 
        }catch(error){
            throw error.response?.data || error.message; 
        }  
    },

    // 删除地址
    async deleteAddress(id){
        try{
            const response = await axiosInstance.delete(`/address/delete/${id}`)
            return response.data;
        }catch(error){
            throw error.response?.data || error.message;
        }
    }
}

export default AddressServer;